<template>
  <wo-region>
    <form autocomplete="off" v-if="categories">
      <wo-label v-t="'reco.browse.category'"></wo-label>
      <po-selector v-model="category" :options="categories.items" v-focus="true" />

      <template v-if="category && brands">
        <wo-label v-t="'reco.browse.brand'"></wo-label>
        <po-selector v-model="brand" :options="brands.items" v-focus="true" />
      </template>

      <template v-if="brand && models">
        <wo-label v-t="'reco.browse.model'"></wo-label>
        <po-selector v-model="model" :options="models.items" v-focus="true" />
      </template>
    </form>
  </wo-region>
</template>
<script>

import { mapState } from 'vuex'
import { recoCategoryRepository, recoBrandRepository, recoModelRepository, recoTypeRepository } from '@/repository/reco'

export default {
  data () {
    return {
      category: undefined,
      brand: undefined,
      model: undefined,
      type: undefined
    }
  },
  computed: mapState({
    categories: state => state.reco.recoCategoryList,
    brands: state => state.reco.recoBrandList,
    models: state => state.reco.recoModelList
  }),
  created () {
    this.$store.dispatch(recoCategoryRepository.findAll)
  },
  watch: {
    category () {
      this.category && this.$store.dispatch(recoBrandRepository.findAll, this.createFindAllPayload())
      this.brand = undefined
    },
    brand () {
      this.brand && this.$store.dispatch(recoModelRepository.findAll, this.createFindAllPayload())
      this.model = undefined
    },
    model () {
      if (this.model) {
        this.$store.dispatch(recoTypeRepository.findAll, this.createFindAllPayload(true))
          .then(result => this.$emit('input', result))
      } else {
        this.emitEmpty()
      }
    }
  },
  methods: {
    createFindAllPayload (replace) {
      return {
        categoryId: this.category && this.category.id,
        brandId: this.brand && this.brand.id,
        modelId: this.model && this.model.id,
        replace
      }
    },
    emitEmpty () {
      this.$emit('input')
    }
  }
}
</script>
